import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  MenuItem,
  Box,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { createOrEditNomineeRequest } from "../../../redux/customer/CustomerSlice";
import { getActiveCountriesRequest } from "../../../redux/CountryList/CountrySlice";
import { toast } from "react-toastify";
import auth from "../../../configs/auth";
const relations = ["Father", "Mother", "Spouse", "Brother", "Sister", "Other"];

const NomineeDialog = ({ open, onClose, customer }) => {
  const dispatch = useDispatch();
  console.log("customer", customer);
  const { activeCountries = [] } = useSelector((state) => state.country || {});
  const [selectedDialCode, setSelectedDialCode] = useState("+91");
  const [selectedPhoneLength, setSelectedPhoneLength] = useState(10);
  const [countryStates, setCountryStates] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const jeweller = sessionStorage.getItem(auth.selectedJeweller);
  const [selectedJewellerId, setSelectedJewellerId] = useState(() => {
              return sessionStorage.getItem(auth.selectedJeweller) || "";
            });
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const jewellerID = storedUser?.jeweller;
      const finalJewellerId =
      selectedJewellerId && selectedJewellerId.trim() !== ""
      ? selectedJewellerId
      : jewellerID;
  useEffect(() => {
    dispatch(getActiveCountriesRequest({ jeweller:finalJewellerId }));
  }, [dispatch]);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    age: "",
    relation: "",
    identity_id: "",
    identity_type: "",
    address: "",
    state: "",
    country: "",
    customer: "",
  });

  useEffect(() => {
    if (customer?.nominee) {
      const selectedCountry = activeCountries.find(
        (c) => c.countryName === customer.nominee.country
      );

      setSelectedCountryId(selectedCountry?._id || "");
      setCountryStates(selectedCountry?.states || []);
      setSelectedDialCode(selectedCountry?.dialCode || "+91");
      setSelectedPhoneLength(selectedCountry?.phoneLength || 10);
      setForm({
        _id: customer.nominee._id,
        firstName: customer.nominee.firstName || "",
        lastName: customer.nominee.lastName || "",
        phone: customer.nominee.phone || "",
        age: customer.nominee.age || "",
        relation: customer.nominee.relation || "",
        identity_id: customer.nominee.identity_id || "",
        identity_type: customer.nominee.identity_type || "",
        address: customer.nominee.address || "",
        state: customer.nominee.state || "",
        country: customer.nominee.country || "",
        customer: customer._id,
      });
    } else {
      setForm({
        firstName: "",
        lastName: "",
        phone: "",
        age: "",
        relation: "",
        identity_id: "",
        identity_type: "",
        address: "",
        state: "",
        country: "",
        customer: customer?._id || "",
      });
    }
  }, [customer, activeCountries]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const resetCountrySelection = () => {
    setSelectedCountryId("");
    setCountryStates([]);
    setSelectedDialCode("+91");
    setSelectedPhoneLength(10);
  };

  const handleSubmit = () => {
    if (!form.firstName || !form.lastName) {
      toast.warning("First and last name are required");
      return;
    }

    if (form.phone.length !== selectedPhoneLength) {
      toast.warning(`Phone number must be ${selectedPhoneLength} digits`);
      return;
    }
    dispatch(createOrEditNomineeRequest(form));
    resetCountrySelection();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        fontFamily={"Aeonik"}
        fontWeight={700}
        fontSize={24}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
          color: "#fff",
        }}
      >
        Nominee Details
        <IconButton
          onClick={() => {
            resetCountrySelection();
            onClose();
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2} mt={3}>
          <TextField
            label="First Name"
            name="firstName"
            value={form.firstName}
            onChange={(e) => {
              const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              setForm({ ...form, firstName: onlyAlphabets });
            }}
            fullWidth
          />

          <TextField
            label="Last Name"
            name="lastName"
            value={form.lastName}
            onChange={(e) => {
              const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              setForm({ ...form, lastName: onlyAlphabets });
            }}
            fullWidth
          />

          <FormControl fullWidth>
            <InputLabel id="country-label">Select Country</InputLabel>
            <Select
              labelId="country-label"
              value={selectedCountryId}
              label="Select Country"
              onChange={(e) => {
                const selected = activeCountries.find(
                  (c) => c._id === e.target.value
                );

                setSelectedCountryId(selected._id);
                setCountryStates(selected?.states || []);

                setSelectedDialCode(selected?.dialCode || "+91");
                setSelectedPhoneLength(selected?.phoneLength || 10);

                setForm((prev) => ({
                  ...prev,
                  country: selected.countryName,
                  state: "",
                }));
              }}
            >
              {activeCountries.map((country) => (
                <MenuItem key={country._id} value={country._id}>
                  {country.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Select State</InputLabel>
            <Select
              value={form.state}
              label="Select State"
              onChange={(e) =>
                setForm((prev) => ({ ...prev, state: e.target.value }))
              }
            >
              {countryStates.map((state) => (
                <MenuItem key={state} value={state}>
                  {state}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Phone"
            name="phone"
            value={form.phone}
            onChange={(e) => {
              const digitsOnly = e.target.value.replace(/\D/g, "");
              if (digitsOnly.length <= selectedPhoneLength) {
                setForm((prev) => ({ ...prev, phone: digitsOnly }));
              }
            }}
            InputProps={{
              startAdornment: (
                <Typography sx={{ mr: 1 }}>{selectedDialCode}</Typography>
              ),
            }}
            fullWidth
          />

          <TextField
            label="Age"
            name="age"
            type="number"
            value={form.age}
            onChange={(e) => {
              const onlyDigits = e.target.value.replace(/\D/g, "");
              setForm({ ...form, age: onlyDigits });
            }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            fullWidth
          />
          <TextField
            label="Identity Type"
            name="identity_type"
            value={form.identity_type}
            onChange={(e) => {
              const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              setForm({ ...form, identity_type: onlyAlphabets });
            }}
            fullWidth
          />

          <TextField
            label="Identity ID"
            name="identity_id"
            value={form.identity_id}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            select
            label="Relation"
            name="relation"
            value={form.relation}
            onChange={handleChange}
            fullWidth
          >
            {relations.map((r) => (
              <MenuItem key={r} value={r}>
                {r}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="Address"
            name="address"
            value={form.address}
            onChange={handleChange}
            fullWidth
          />
        </Box>

        <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
          <Button
            onClick={() => {
              resetCountrySelection();
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Save Nominee
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NomineeDialog;
